import { useMemo } from "react";

import { useGetScoreQuery } from "@/pages/Private/redux/score/score.api";
import { scoreSelector } from "@/pages/Private/redux/score/score.slice";
import { listSelector } from "@/pages/Private/redux/list/list.slice";

import { useAppSelector } from "@/redux/hooks";

/**
 * Persona categories available for the form, narrowed to those linked to the list's
 * selected company score categories (or all when none are selected).
 */
export const usePersonaCategories = () => {
	useGetScoreQuery();
	const { score } = useAppSelector(scoreSelector);
	const { scoreCompanyCategories } = useAppSelector(listSelector);

	return useMemo(() => {
		const allPersonaCategories = score?.prospectPersonaCategories ?? [];

		if (scoreCompanyCategories.length === 0) {
			return allPersonaCategories;
		}

		const selectedIds = new Set(
			scoreCompanyCategories.map((c) => c.id).filter((id): id is number => id !== undefined)
		);

		return allPersonaCategories.filter((persona) =>
			persona.scoreCompanyCategories.some((cc) => cc.id !== undefined && selectedIds.has(cc.id))
		);
	}, [score?.prospectPersonaCategories, scoreCompanyCategories]);
};
